// Kanzleiangaben am 11.10.2026 gegen die Kanzleiwebsite und ausgestellte Rechnungen abgeglichen.
export function Impressum() {
  return (
    <article className="seite">
      <h1>Impressum</h1>

      <h2>Anbieter</h2>
      <p>
        GQL Gussone Quecke Legal Partnerschaft von Rechtsanwälten mbB
        <br />
        Rubensstraße 114
        <br />
        12157 Berlin (Postanschrift)
      </p>
      <p>
        Hauptkanzlei: Strausberger Platz 19, 10243 Berlin
        <br />
        E-Mail: <a href="mailto:quecke@gql-partner.de">quecke@gql-partner.de</a> · Internet:{' '}
        <a href="https://www.gql-partner.de">www.gql-partner.de</a>
        <br />
        Telefon: <a href="tel:+493091519940">+49 30 9151 9940</a>
      </p>

      <h2>Vertretungsberechtigte Partner</h2>
      <p>Rechtsanwalt Dr. Peter Gussone, Rechtsanwalt Moritz Quecke</p>

      <h2>Registereintrag</h2>
      <p>Partnerschaftsregister des Amtsgerichts Charlottenburg, PR 1615</p>

      <h2>Umsatzsteuer-Identifikationsnummer</h2>
      <p>DE347585135</p>

      <h2>Berufsbezeichnung und zuständige Kammer</h2>
      <p>
        Die Partner führen die Berufsbezeichnung „Rechtsanwalt“, verliehen in der Bundesrepublik Deutschland. Zuständige
        Aufsichtsbehörde ist die Rechtsanwaltskammer Berlin, Littenstraße 9, 10179 Berlin ({' '}
        <a href="https://www.rak-berlin.de">www.rak-berlin.de</a>).
      </p>

      <h2>Berufsrechtliche Regelungen</h2>
      <p>
        Bundesrechtsanwaltsordnung (BRAO), Berufsordnung für Rechtsanwälte (BORA), Fachanwaltsordnung (FAO),
        Rechtsanwaltsvergütungsgesetz (RVG) und die Berufsregeln der Rechtsanwälte der Europäischen Union (CCBE). Die
        Texte sind über die <a href="https://www.brak.de/anwaltschaft/berufsrecht/">Bundesrechtsanwaltskammer</a> abrufbar.
      </p>

      <h2>Berufshaftpflichtversicherung</h2>
      <p>
        GQL Rechtsanwälte und ihre Partner unterhalten die erforderliche Berufshaftpflichtversicherung bei der
        Nürnberger Allgemeine Versicherung AG, Ostendstraße 100, 90334 Nürnberg.
      </p>
      <p>Der räumliche Geltungsbereich umfasst:</p>
      <ol>
        <li>
          die weltweite Tätigkeit im Zusammenhang mit der Beratung und Beschäftigung mit europäischem Recht sowie
          dem Recht der Türkei und außereuropäischer Hoheitsgebiete europäischer Staaten, die der Europäischen Union
          oder dem Europäischen Wirtschaftsraum angehören;
        </li>
        <li>
          Tätigkeiten vor europäischen Gerichten sowie Gerichten der unter Nr. 1 genannten Hoheitsgebiete in
          europäischem Recht oder dem Recht des jeweiligen Hoheitsgebiets; vor türkischen Gerichten besteht
          Versicherungsschutz auch in türkischem Recht;
        </li>
        <li>
          die weltweite Inanspruchnahme wegen Haftpflichtansprüchen aus der Beratung und Beschäftigung mit
          europäischem Recht. Bei Inanspruchnahme vor einem außereuropäischen Gericht besteht Versicherungsschutz
          nur in Höhe der gesetzlich vorgeschriebenen Mindestpflichtversicherungssumme.
        </li>
      </ol>

      <h2>Verantwortlich im Sinne des § 18 Abs. 2 MStV</h2>
      <p>Rechtsanwalt Moritz Quecke, Rubensstraße 114, 12157 Berlin</p>

      <h2>Streitbeilegung</h2>
      <p>
        Bei Streitigkeiten zwischen Rechtsanwälten und ihren Auftraggebern kann die Schlichtungsstelle der
        Rechtsanwaltschaft (Rauchstraße 26, 10787 Berlin,{' '}
        <a href="https://www.schlichtungsstelle-der-rechtsanwaltschaft.de">www.schlichtungsstelle-der-rechtsanwaltschaft.de</a>) angerufen
        werden (§ 191f BRAO). Zur Teilnahme an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind
        wir im Übrigen nicht verpflichtet.
      </p>

      <h2>Zweck dieses Portals</h2>
      <p>
        Das Portal „Aufschaltgebiete Brandmeldeanlagen“ dient ausschließlich dem Austausch von Unterlagen und
        Auswertungen zwischen GQL und den von GQL eingeladenen Personen auf Grundlage einer gesonderten Vereinbarung.
        Es richtet sich nicht an die Öffentlichkeit.
      </p>
    </article>
  );
}
